import { render, staticRenderFns } from "./RadioStage.vue?vue&type=template&id=31abf3c0&"
import script from "./RadioStage.vue?vue&type=script&lang=js&"
export * from "./RadioStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports